import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';

const IndividualSession = ({ eventId, isSessionView, limitMet, session }) => (
  <>
    <Text variant={TEXT_VARIANTS.BODY_BOLD}>{session.name}</Text>
    <SessionDetails
      adminView={false}
      className="mt-10"
      eventId={eventId}
      hasMultipleSessions
      isSessionView={isSessionView}
      limitMet={limitMet}
      session={session}
      showVideoMeetingUrl={false}
    />
  </>
);

export default IndividualSession;
